import React from 'react';
import { Section } from './Shared';
import { Star } from './HalloweenDecor';
export function EmotionalTransition() {
  return <Section tone="white" innerClassName="max-w-3xl text-center" data-id="element-52" data-mp="2udn4597eaykp">
      <Star className="mx-auto mb-5 w-6 text-brand-orange" data-id="element-53" data-mp="2fqlkj0ftjvsx" />
      <h2 className="text-balance text-[30px] font-extrabold leading-[1.15] text-brand-violet md:text-[44px]" data-id="element-54" data-mp="2fnzej58ktoct">
        Este año, el plan puede empezar con una idea compartida.
      </h2>
      <p className="mt-5 text-base leading-relaxed text-brand-ink/85 md:text-xl md:leading-relaxed" data-id="element-55" data-mp="26o2igijuxn7q">
        Elegir el personaje. Buscar los materiales. Probar colores. Reírse cuando algo sale distinto. Crear el disfraz
        puede ser una actividad en familia, además de preparar lo que van a usar en Halloween.
      </p>
    </Section>;
}